import { render, staticRenderFns } from "./swGrowth.vue?vue&type=template&id=456e121d&scoped=true"
import script from "./swGrowth.vue?vue&type=script&lang=js"
export * from "./swGrowth.vue?vue&type=script&lang=js"
import style1 from "./swGrowth.vue?vue&type=style&index=1&id=456e121d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e121d",
  null
  
)

export default component.exports